"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IP_WHITELIST = void 0;
exports.IP_WHITELIST = [
    '88.149.56.61',
    '88.149.58.166',
    '88.149.58.115',
    '212.30.230.128',
    '212.30.230.129',
    '194.144.238.190',
    '82.221.9.48',
    '85.94.70.186',
];
//# sourceMappingURL=Constants.js.map